"use strict";

var _defineProperty = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _slicedToArray = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = useLDflex;
exports.toString = toString;

var _react = require("react");

var _useWebId = _interopRequireDefault(require("./useWebId"));

var _useLiveUpdate = _interopRequireDefault(require("./useLiveUpdate"));

var _ExpressionEvaluator = _interopRequireDefault(require("../ExpressionEvaluator"));

var value = {
  result: undefined,
  pending: true,
  error: undefined
};
var list = {
  result: [],
  pending: true,
  error: undefined
};
var none = {};
/**
 * Evaluates the Solid LDflex expression.
 * Returns an array of [result, pending, error].
 */

function useLDflex(expression) {
  var listMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  // The user's WebID and recent updates might influence the evaluation
  var webId = (0, _useWebId.default)();
  var latestUpdate = (0, _useLiveUpdate.default)(); // Obtain the latest expression result from the state

  var _ref = (0, _react.useState)(listMode ? list : value),
      _ref2 = _slicedToArray(_ref, 2),
      _ref2$ = _ref2[0],
      result = _ref2$.result,
      pending = _ref2$.pending,
      error = _ref2$.error,
      update = _ref2[1];

  (0, _react.useDebugValue)(error || result, toString); // Set up the expression evaluator

  (0, _react.useEffect)(function () {
    var evaluator = new _ExpressionEvaluator.default();
    var query = {
      result: expression
    };
    evaluator.evaluate(!listMode ? query : none, listMode ? query : none, function (changed) {
      return update(function (current) {
        return _objectSpread({}, current, {}, changed);
      });
    });
    return function () {
      return evaluator.destroy();
    };
  }, [expression, latestUpdate, webId && typeof expression === 'string']); // Return the state components

  return [result, pending, error];
}

function toString(object) {
  return Array.isArray(object) ? object.map(toString) : "".concat(object);
}